export default {"src":"/_next/static/media/excel-doc.19cd002a.svg","height":40,"width":40};